import axios from 'axios';

const REGIONS_API = '/api/v2/tables/regions';

/** Регион справочника со счетчиками привязанных сотрудников и терминалов */
export interface Region {
  id: number;
  name: string;
  createdAt: string | null;
  updatedAt: string | null;
  usersCount: number;
  terminalsCount: number;
}

/** Сколько записей перенесено на новое название при переименовании региона */
export interface RenameResult {
  users: number;
  terminals: number;
}

interface ListResponse {
  success?: boolean;
  data?: Region[];
}

interface UpdateResponse {
  success?: boolean;
  moved?: Partial<RenameResult>;
}

export async function fetchRegions(): Promise<Region[]> {
  const res = await axios.get<ListResponse>(REGIONS_API);
  if (!res.data || !res.data.success || !Array.isArray(res.data.data)) {
    throw new Error('Сервер вернул список регионов в неожиданном виде');
  }
  return res.data.data;
}

export async function createRegion(name: string): Promise<void> {
  await axios.post(REGIONS_API, { name: name.trim() });
}

/** Переименовывает регион; сервер переносит новое название сотрудникам и терминалам и возвращает, сколько их */
export async function updateRegion(id: number, name: string): Promise<RenameResult> {
  const res = await axios.put<UpdateResponse>(`${REGIONS_API}/${id}`, { name: name.trim() });
  const moved = (res.data && res.data.moved) || {};
  return { users: Number(moved.users) || 0, terminals: Number(moved.terminals) || 0 };
}

export async function deleteRegion(id: number): Promise<void> {
  await axios.delete(`${REGIONS_API}/${id}`);
}
